import {
    Text,
    View,
} from "@react-pdf/renderer";
import { useEffect } from "react";
import { LabelType } from "../../../router/pdfdownload";

export default function TableGaji ({listDebit, listCredit} : {listDebit: LabelType[], listCredit: LabelType[]}){
    let totalDebit: number = 0
    let totalCredit: number = 0
    listDebit.length > 0 && listDebit.map((item: LabelType) => totalDebit += item.value)
    listCredit.length > 0 && listCredit.map((item: LabelType) => totalCredit += item.value)
    return (
        <>
            <View style={{ flexDirection: "row" }} >
                <View style={{ width: "50%" }}>
                    <Text style={{ fontWeight: "bold", fontSize: 14, marginBottom: 10 }}>Pendapatan</Text>
                    {
                        (listDebit && listDebit.length > 0) && listDebit.map((item: any) => (item.label.trim() !== "") && TableRow(item.label, item.value))
                    }
                </View>
                <View style={{ width: "50%" }}>
                    <Text style={{ fontWeight: "bold", fontSize: 14, marginBottom: 10 }}>Potongan</Text>
                    {
                        (listCredit && listCredit.length > 0) && listCredit.map((item: any) => (item.label.trim() !== "") &&  TableRow(item.label, item.value))
                    }
                </View>
            </View>
            <View style={{ flexDirection: "row" }} >
                <View style={{ width: "50%" }}>
                    {TableRow("Total", totalDebit)}
                </View>
                <View style={{ width: "50%" }}>
                    {TableRow("Total", totalCredit)}
                </View>
            </View>
            <View style={{ borderTop: "1px solid black", marginLeft: "60%", marginVertical: 10 }}></View>
            {TableRow("Jumlah Diterima", (Number(totalDebit) - Number(totalCredit)))}
        </>
    )
}

const formatMoney = (inpt: number) => {
    const number_string = inpt.toFixed(2).toString()
    const sisa = number_string.length % 3
    let rupiah = number_string.substring(0, sisa)
    const ribuan = number_string.substring(sisa).match(/\d{3}/g)

    if (ribuan) {
        let separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
    }
    return rupiah
}
const TableRow = (name: string, value: number) => {
    return (
        <View key={name} style={{ flexDirection: "row", marginVertical: 3, fontSize: 12 }}>
            <View style={{ width: "50%" }}>
                <Text>{name}</Text>
            </View>
            <View style={{ width: "10%" }}>
                <Text>:</Text>
            </View>
            <View style={{ width: "30%", textAlign: "right" }}>
                <Text>Rp. {formatMoney(value)}</Text>
            </View>
        </View>
    )
}